import React from 'react';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';

interface NumberOfResponsesProps {
  totalCount: number;
}

export const NumberOfResponses: React.FC<NumberOfResponsesProps> = ({ totalCount }) => (
  <Text size="b_md" color="bodySecondary">
    {totalCount ? (
      <I18n k={`brief_preview_drawer.seller.numberOfResponses`} params={{ count: totalCount }} />
    ) : (
      <I18n k="brief_preview_drawer.seller.numberOfResponses.be_the_first" />
    )}
  </Text>
);
